export default "__VITE_ASSET__BP86leNX__"